export interface IUserViewDto {
	id: string;
	firstName?: string;
	locationName?: string;
	corporationName?: string;
	dealerName?: string;
	lastName?: string;
	phone: string;
	phoneCountryCode: string;
	email: string;
	isDisabled: boolean;
	adminType?: string;
	tier?: string;
	tierName?: string;
	tierId: string;
	dealerId?: string;
	corporationId?: string;
	locationId?: string;
	name: string;
	role: string;
}

export interface IUserDetailsDto {
	id: string;
	firstName: string;
	lastName: string;
	corporationId?: string;
	corporationName?: string;
	locationId?: string;
	locationName?: string;
	email: string;
	phone: string;
	pin: string;
	isActive: boolean;
	adminType: string;
}

export enum userType {
	DealerAdmin = 1,
	CorporationAdmin = 2,
	LocationAdmin = 3,
}

export enum DictUserRole {
	LocationAdmin = 1,
	CorporationAdmin = 2,
	LocationKeeper = 3,
	DealerAdmin = 4,
	SuperAdmin = 5,
	User = 6,
}
